interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-2-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
        <i className={`${icon} text-3xl`} aria-hidden="true"></i>
      </span>
      <h3 className="text-base font-semibold text-foreground-800">{title}</h3>
      {description && (
        <p className="mt-1.5 text-sm text-foreground-500 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}